import React from 'react';
import { Helmet } from 'react-helmet-async';

const Brands = () => {
    return (
        <div>
            <Helmet>
                <title>Fashion Brands - Tiger Mist, Levi's, Cotton On & More | The Sidewalk</title>
                <meta name="description" content="Explore our curated collection of emerging fashion brands including Tiger Mist, Levi's, Cotton On, and 33mm. Discover unique styles from up-and-coming designers." />
                <meta property="og:title" content="Fashion Brands | The Sidewalk" />
                <meta property="og:description" content="Explore emerging fashion brands curated by The Sidewalk." />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://thesidewalk.co/brands" />
                <link rel="canonical" href="https://thesidewalk.co/brands" />
            </Helmet>
            <h1>Brands Page</h1>
            <p>This is the brands page content.</p>
        </div>
    );
};

export default Brands;